import { useLocation } from "react-router-dom";

/**
 * Returns "/admin" or "/me" depending on where the user currently is —
 * lets pages that mount under both prefixes (Payments Oversight, Invoices,
 * Clients, Org KB) link to the right sibling URL without hardcoding.
 *
 * Default falls back to "/admin" so anything outside the two known
 * employee prefixes keeps the existing behaviour.
 */
export function useNamespace() {
  const { pathname } = useLocation();
  return pathname.startsWith("/me/") || pathname === "/me" ? "/me" : "/admin";
}
